import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    coordinates: null
  },
  getters: {
    showInfoPcmiler(state) {
      return state.coordinates;
    }
  },
  mutations: {
    setCoordinates(state, newCoordinates) {
      state.coordinates = newCoordinates;
    }
  },
  actions: {
    async getCoordinatesMap({ commit }, cityInfo) {
      let response;
      try {
        response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/pcmiler?haul_id=${cityInfo.haul_id}&city_to=${cityInfo.city_to}&state_to=${cityInfo.state_to}&zipCode_to=${cityInfo.zipCode_to}&country_to=${cityInfo.country_to}&city_from=${cityInfo.city_from}&state_from=${cityInfo.state_from}&zipCode_from=${cityInfo.zipCode_from}&country_from=${cityInfo.country_from}`,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setCoordinates", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
